import { v4 as uuidv4 } from 'uuid';
import type { GroupChildLayer, Layer } from './types';

const DUPLICATE_OFFSET = 20;

// Fresh ids (recursively for groups) + stripped identity/links so the copy is standalone.
const withFreshIds = <L extends Layer | GroupChildLayer>(layer: L): L => {
  const copy = structuredClone(layer);
  copy.id = uuidv4();
  delete copy.pieceId; // pieceId is a binding role; a duplicate must not share it
  if (copy.kind !== 'audio') {
    delete copy.attachTo; // don't re-anchor to the original's siblings
    if (copy.kind === 'group') {
      copy.content = { ...copy.content, children: copy.content.children.map(withFreshIds) };
    }
  }
  return copy;
};

/** A standalone copy of a layer: fresh ids, no pieceId/attachTo, offset so it's visible. */
export const duplicateLayer = (layer: Layer): Layer => {
  const copy = withFreshIds(layer);
  if (copy.kind !== 'audio') {
    // The copy drops attachTo, so it needs a standalone position (a chained original had none).
    copy.left = (copy.left ?? 0) + DUPLICATE_OFFSET;
    copy.top = (copy.top ?? 0) + DUPLICATE_OFFSET;
  }
  return copy;
};
